export const schedule = [
  {
    day: "DAY 1 — THURSDAY, JAN 08",
    title: "ARRIVAL & GROUNDING",
    items: [
      { time: "10:00-14:00", activity: "Check-in", desc: "Arrive anytime between 10am-2pm. Take your time settling in." },
      { time: "14:00-15:30", activity: "Welcome buffet", desc: "Fresh vegan food. Herbal tea. Get to know each other over a meal." },
      { time: "15:30-17:00", activity: "Welcome circle & orientation", desc: "Setting intentions together. Introductions. Space tour." },
      { time: "17:00-20:00", activity: "CREATIVE CIRCLE 1: First Gestures", desc: "Breaking the ice through making. Hands before words. Intuitive marks. Getting to know the materials. Building trust." },
      { time: "20:00-21:30", activity: "Dinner", desc: "" },
      { time: "21:30+", activity: "Free time", desc: "Rest, chat, or enjoy the night air." }
    ]
  },
  {
    day: "DAY 2 — FRIDAY, JAN 09",
    title: "GRAVURE & INTUITIVE CARVING",
    items: [
      { time: "07:30-08:30", activity: "Morning yoga (Optional)", desc: "Gentle flow. No experience needed. Sleep in if you prefer." },
      { time: "08:30-10:00", activity: "Breakfast", desc: "" },
      { time: "10:00-13:00", activity: "CREATIVE CIRCLE 2: Gravure & Automatic Marks", desc: "Carving into linoleum. Knife meets surface. What emerges when you cut away? Printing your marks. No sketches first—let the blade guide you." },
      { time: "13:00-14:30", activity: "Lunch", desc: "" },
      { time: "14:30-17:30", activity: "Assisted free experimentation", desc: "Continue carving, try different printing techniques, play with layering. Facilitators available for questions—not to direct, just to support." },
      { time: "18:00-20:00", activity: "Dinner", desc: "" },
      { time: "20:00+", activity: "Free time", desc: "Your evening. Rest, create, walk, or do nothing at all." }
    ]
  },
  {
    day: "DAY 3 — SATURDAY, JAN 10",
    title: "SOUND, COLLECTIVE RESONANCE & TACTILE CREATION",
    items: [
      { time: "07:30-08:30", activity: "Morning yoga (Optional)", desc: "" },
      { time: "08:30-10:00", activity: "Breakfast", desc: "" },
      { time: "10:00-13:00", activity: "CREATIVE CIRCLE 3: Sound & Sensation", desc: "Voice, objects, field recordings. Making noise together. Collective resonance. Your body as instrument." },
      { time: "13:00-14:30", activity: "Lunch", desc: "" },
      { time: "14:30-17:30", activity: "CREATIVE CIRCLE 4: Tactile Creation & Visual Dialogue", desc: "Clay, fabric, found objects. Creating without seeing first. Touch as language. Texture as memory." },
      { time: "18:00-20:00", activity: "Dinner", desc: "" },
      { time: "20:00+", activity: "Free time", desc: "Rest. Integrate. Stargaze. Walk. Be." }
    ]
  },
  {
    day: "DAY 4 — SUNDAY, JAN 11",
    title: "INTEGRATION & CLOSING",
    items: [
      { time: "07:30-08:30", activity: "Morning yoga (Optional)", desc: "" },
      { time: "08:30-10:00", activity: "Breakfast", desc: "" },
      { time: "10:00-13:00", activity: "CREATIVE CIRCLE 5: Watercolor & Creative Traces", desc: "What wants to be painted? Color meeting water. Bringing it all together. Celebrating \"mistakes\". Making peace with imperfection." },
      { time: "13:00-14:30", activity: "Lunch", desc: "" },
      { time: "14:30-17:00", activity: "Closing circle", desc: "Sharing creations. Reflecting on the journey. What are you taking home? What are you leaving behind? Gratitude. Group photo. Goodbyes." },
      { time: "17:00+", activity: "Departure", desc: "" }
    ]
  }
];
